export default __webpack_public_path__ + "static/media/support_platform_drainage1.3111a056.png";